function mergeLocalizedData(defaultData, localeData, sort = null) {
  const merged = defaultData.map((entry) => {
    const localeEntry = localeData.find((localeEntry) => entry.slug === localeEntry.slug);
    return localeEntry || entry;
  });

  // after the merge the data can loose its initial order so we have to sort again
  if (sort) {
    let direction;
    let sortField;

    if (sort[0] === "-") {
      direction = -1;
      sortField = sort.substring(1, sort.length);
    } else {
      direction = 1;
      sortField = sort;
    }
    return merged.sort((a, b) => direction * a[sortField].localeCompare(b[sortField]));
  } else {
    return merged;
  }
}

export default {
  mergeLocalizedData,
};
